<template>
  <v-row>
    <v-container fluid>
      <v-tabs v-model="tab">
        <v-tab v-for="item in items" :key="item.id">
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.id">
          <third-party-setup-for-owner
            :owner-id="ownerId"
            :value="item"
          ></third-party-setup-for-owner>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <v-container>
      <v-row v-if="debug">
        <code>{{ level }}-{{ items }}</code>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import ThirdPartySetupForOwner from "./ThirdPartySetupForOwner.vue";
const ALL_THIRD_PARTY_SETUPS = gql`
  query allThirdPartySetups {
    thirdPartySetups {
      edges {
        node {
          id
          name
          inUse
          level
          ownerId
          settings {
            edges {
              node {
                id
                name
                content
              }
            }
          }
        }
      }
    }
  }
`;
export default {
  components: { ThirdPartySetupForOwner },
  name: "third-party-setups-for-level",
  props: {
    level: {
      type: String,
      required: true,
    },
    ownerId: {
      type: String,
      required: true,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      tab: null,
    };
  },

  computed: {
    items() {
      return this.thirdPartySetups && this.thirdPartySetups.edges
        ? this.thirdPartySetups.edges
            .map(removeGQLTypename)
            .filter((s) => s.level == this.level && s.ownerId == "")
        : [];
    },
  },

  apollo: {
    thirdPartySetups: {
      query: ALL_THIRD_PARTY_SETUPS,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/third-party-setups/ThirdPartySetupsForLevel.vue